import { render, staticRenderFns } from "./Forwarding.vue?vue&type=template&id=1c3c379a&scoped=true"
import script from "./Forwarding.vue?vue&type=script&lang=js"
export * from "./Forwarding.vue?vue&type=script&lang=js"
import style0 from "./Forwarding.vue?vue&type=style&index=0&id=1c3c379a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3c379a",
  null
  
)

export default component.exports